import { fetchJson } from '~/lib/fetch';
import { getCSRF } from '~/lib/discussions/utils';
import { Comment as CommentType } from '~/lib/discussions/types';
import {
  ApprovalStatus,
  ModerationStatus,
  UserStatus,
} from '~/static/discussions/enums';

export function useComment(comment: CommentType, mutateComment: () => void) {
  const { id, user } = comment;

  const like = async function () {
    try {
      const args = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRFToken': getCSRF(),
        },
        include: 'credentials',
      };
      console.log('LIKE:', args);
      await fetchJson(`/comments/like/${id}/`, args);
      mutateComment();
    } catch (error) {
      console.error(error, { success: false });
    }
  };

  const setApprovalStatus = async function (
    value: ApprovalStatus,
  ): Promise<void> {
    const action = value === ApprovalStatus.Unapproved ? null : value;

    try {
      await fetchJson(
        `/comments/approve_comment_ajx/?comment_id=${id}&approve_action=${action}`,
      );
      mutateComment();
    } catch (error) {
      console.error(error, { value: ApprovalStatus[value], success: false });
    }
  };

  const setGlobalUserStatus = async function (
    type: UserStatus,
    value: boolean = true,
  ): Promise<void> {
    const action = value ? '1' : '0';

    try {
      await fetchJson(
        `/comments/${type}_author_ajx/?user_id=${user.id}&${type}_action=${action}`,
      );
      mutateComment();
    } catch (e) {
      console.error({ type: type, value: value, success: false });
    }
  };

  const setModerationStatus = async function (
    value: ModerationStatus,
  ): Promise<void> {
    const args = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': getCSRF(),
      },
      include: 'credentials',
      body: JSON.stringify({ xtdcomment_ptr_id: id, resolved: value }),
    };

    try {
      await fetchJson(`/discussions/api/resolved/${id}/`, args);
      mutateComment();
    } catch (e) {
      console.error({ action: ModerationStatus[value], success: false });
    }
  };

  const approve = async function (): Promise<void> {
    await setApprovalStatus(ApprovalStatus.Approved);
  };

  const unapprove = async function (): Promise<void> {
    await setApprovalStatus(ApprovalStatus.Unapproved);
  };

  const deny = async function (): Promise<void> {
    await setApprovalStatus(ApprovalStatus.Denied);
  };

  const undeny = unapprove;

  const approveAllPosts = async function (): Promise<void> {
    await setGlobalUserStatus(UserStatus.Whitelist);
  };

  const disableApproveAllPosts = async function (): Promise<void> {
    await setGlobalUserStatus(UserStatus.Whitelist, false);
  };

  const blockUser = async function (): Promise<void> {
    await setGlobalUserStatus(UserStatus.Blacklist);
  };

  const unblockUser = async function (): Promise<void> {
    await setGlobalUserStatus(UserStatus.Blacklist, false);
  };

  const resolve = async function (): Promise<void> {
    await setModerationStatus(ModerationStatus.Resolved);
  };

  const unresolve = async function (): Promise<void> {
    await setModerationStatus(ModerationStatus.Unresolved);
  };

  // todo: helper for pinned? -- not necessarily needed on q/r page

  return {
    approve,
    unapprove,
    approveAllPosts,
    disableApproveAllPosts,
    blockUser,
    unblockUser,
    deny,
    undeny,
    resolve,
    unresolve,
    like,
  };
}
